import { z } from 'zod';
import {
  CurrencySchema,
  InvoiceIdSchema,
  IsoUtcTimestampSchema,
  PeppolParticipantIdSchema,
  TrnSchema,
} from './primitives';

export const TddSubmissionStatusSchema = z.enum([
  'PENDING',
  'SUBMITTED',
  'ACCEPTED',
  'FAILED',
  'DEAD_LETTER',
]);

export const TddSchema = z.object({
  tddId: z.string().uuid(),
  invoiceId: InvoiceIdSchema,
  tddSpecificationId: z.literal('urn:peppol:taxdata:ae-1'),
  senderParticipantId: PeppolParticipantIdSchema,
  sellerTrn: TrnSchema,
  buyerTrn: TrnSchema,
  taxBaseAmount: z.number().nonnegative(),
  vatAmount5pct: z.number().nonnegative().default(0),
  vatAmount0pct: z.number().nonnegative().default(0),
  vatAmountExempt: z.number().nonnegative().default(0),
  currency: CurrencySchema,
  idempotencyKey: z.string().min(1).max(128),
  submissionStatus: TddSubmissionStatusSchema.default('PENDING'),
  retryCount: z.number().int().min(0).max(3).default(0),
  submittedAt: IsoUtcTimestampSchema.optional(),
  emaraConfirmationId: z.string().max(200).optional(),
  deadline: IsoUtcTimestampSchema,
});
export type Tdd = z.infer<typeof TddSchema>;
